const tipoPropiedadMap = [
    {
        "id": "casa",
        "descripcion": "Casa"
    },
    {
        "id": "country",
        "descripcion": "Country"
    },
    {
        "id": "edificio",
        "descripcion": "Edificio/ph"
    },
    {
        "id": "comercio",
        "descripcion": "Comercio"
    },
    {
        "id": "complejo",
        "descripcion": "Complejo/Monoblock"
    }
]

export default tipoPropiedadMap;